import axios from 'axios';
import router from '../router/index.js'

// const prefixUrl = 'http://hb.ysan.club/blueapi'
// const prefixUrl = 'https://qd.xindehe.cn/blueapi'
 const prefixUrl = 'https://www.hjbwg.mil.cn/blueapi'
 const prefixUrlTicket = 'https://www.hjbwg.mil.cn/ticketapi'
//const prefixUrl = 'http://localhost:8091' 

// const prefixUrl = 'http://hb.wuxi.fmone.cn'

//const prefixUrl = 'http://localhost:18091'
//const prefixUrlTicket = 'http://localhost:18091'



let util = {};

util.setStorage = function(key, value) {
	window.localStorage.setItem(key, value);
}

util.getStorage = function(key) {
	let result = window.localStorage.getItem(key);
	return result;
}

//  删除全局参数
util.delStorage = function (key) {
	window.localStorage.removeItem(key);
};

/**
 * @desc 请求拦截
 */
axios.interceptors.request.use(
    config => {
        let token = util.getStorage('token');
        if (token) {
            config.headers['authToken'] = token;
        }
		config.headers['Content-Type'] = 'application/json';
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

/**
 * @desc 响应拦截
 */
axios.interceptors.response.use(
    response => {
		if(response.data.code === 'F001') {
			router.replace({
				path: '/login',
				query: { redirect: router.currentRoute.fullPath }
			})
		}
        return response
    },
    error => {
        const code = error.response.status;
        switch (code) {
            case 401:
                Message.info('请先登录')
				// 返回 401 清除token信息并跳转到登录页面
				util.delStorage('token')
				util.delStorage('userInfo')
				router.replace({
					path: '/login',
					query: { redirect: router.currentRoute.fullPath }
				})
                return Promise.reject(error);
            case 415:
                alert('Access is too frequent. Please try again later.')
                return Promise.reject(error);
        }
    }
)

util.get  = function (obj) {
	return new Promise((resolve, reject) => {
		let urlStr = (obj.url.indexOf('/ticket/') > -1 || obj.url.indexOf('/activityOrder/') > -1 || obj.url.indexOf('/activity/') > -1) ? prefixUrlTicket : prefixUrl
		axios.get(urlStr + obj.url, {
			params: obj.data,
		}).then(res => {
			resolve(res.data);
		}).catch(err => {
			reject(err.data)
		})
	});
};

util.post  = function (obj) {
	return new Promise((resolve, reject) => {
		let urlStr = (obj.url.indexOf('/ticket/') > -1 || obj.url.indexOf('/activityOrder/') > -1 || obj.url.indexOf('/activity/') > -1) ? prefixUrlTicket : prefixUrl
		axios.post(urlStr + obj.url, obj.data).then(res => {
			resolve(res.data);
		})
		.catch(err => {
			reject(err);
		})
	});
}

util.put  = function (obj) {
	return new Promise((resolve, reject) => {
		let urlStr = (obj.url.indexOf('/ticket/') > -1 || obj.url.indexOf('/activityOrder/') > -1 || obj.url.indexOf('/activity/') > -1) ? prefixUrlTicket : prefixUrl
		axios.put(urlStr + obj.url, obj.data).then(res => {
			resolve(res.data);
		})
		.catch(err => {
			reject(err);
		})
	});
}

util.del = function (obj) {
	return new Promise((resolve, reject) => {
		axios.delete(prefixUrl + obj.url, {
			data: obj.data
		}).then(res => {
			resolve(res.data);
		})
		.catch(err => {
			reject(err.data)
		})
	});
}

export default util;



// WEBPACK FOOTER //
// ./src/libs/http.js